import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    saveProfileInfo: null,
    profileData: {},
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.GET_PROFILE_REQUEST:
      return {
        saveProfileInfo: null,
        profileData: {},
        isProgress: true,
      };
    case homeConstants.GET_PROFILE_SUCCESS: {
      const { data } = action.response;
      if (data && Object.keys(data).length) {
        const info = {
          email: data.email,
          phone: data.phone,
        };
        sessionStorage.setItem("userData", JSON.stringify(info));
      }
      return {
        profileData: action.response,
        saveProfileInfo: null,
        isProgress: false,
      };
    }
    case homeConstants.GET_PROFILE_FAILURE:
      return {
        profileData: {},
        saveProfileInfo: null,
        error: action.error,
        isProgress: false,
      };
    case homeConstants.SAVE_PROFILE_REQUEST:
      return {
        ...state,
        saveProfileInfo: null,
        isProgress: true,
      };
    case homeConstants.SAVE_PROFILE_SUCCESS:
      return {
        ...state,
        saveProfileInfo: action.response,
        isProgress: false,
      };
    case homeConstants.SAVE_PROFILE_FAILURE:
      return {
        saveProfileInfo: null,
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_SAVE_PROFILE:
      return {
        ...state,
        saveProfileInfo: null,
        error: action.error,
        isProgress: false,
      };
    default:
      return state;
  }
}
